import { render, staticRenderFns } from "./fieldDetail.vue?vue&type=template&id=2d72a1da&scoped=true"
import script from "./fieldDetail.vue?vue&type=script&lang=js"
export * from "./fieldDetail.vue?vue&type=script&lang=js"
import style0 from "./fieldDetail.vue?vue&type=style&index=0&id=2d72a1da&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72a1da",
  null
  
)

export default component.exports